import ImpressionEvent from './ImpressionEvent'

export default ImpressionEvent
